import { getFatorVencimento } from '@/utils/getFatorVencimento';
import { IGerarBoletoSicredi } from './types';
import { copy } from '@/utils/copy';

export function gerarDadosBoleto({ dados }: IGerarBoletoSicredi) {
  try {
    const { bancario, parcela } = dados;

    parcela.valor = Number(parcela.valor);

    const fatorVencimento = getFatorVencimento(parcela.vencimento);
    const valor = getValor(parcela.valor);
    const nossoNumero = getNossoNumero(
      parcela.numeroUnico,
      bancario.agencia,
      bancario.posto,
      bancario.codigoCedente
    );

    let campoLivre = bancario.tipoCobranca + bancario.tipoCarteira + nossoNumero + bancario.agencia.padStart(4, '0')
      + bancario.posto.padStart(2, '0') + bancario.codigoCedente.padStart(5, '0') + 10;

    const digitoCampoLivre = getDigitoCampoLivre(campoLivre);
    campoLivre = campoLivre + digitoCampoLivre;
    const digitoGeral = getDigitoGeral(`7489${fatorVencimento}${valor}${campoLivre}`);

    const codigoBarra = `7489${digitoGeral}${fatorVencimento}${valor}${campoLivre}`;

    const campo1 = copy(codigoBarra, 1, 3) + copy(codigoBarra, 4, 4) + copy(codigoBarra, 20, 24);
    const campo2 = copy(codigoBarra, 25, 34);
    const campo3 = copy(codigoBarra, 35, 44);
    const campo4 = copy(codigoBarra, 5, 5);
    const campo5 = copy(codigoBarra, 6, 9) + copy(codigoBarra, 10, 19);

    const digito1 = getDigito(campo1);
    const digito2 = getDigito(campo2);
    const digito3 = getDigito(campo3);
    // const digito4 = getDigito(campo4);
    const linhaDigitavel = campo1 + digito1 + campo2 + digito2 + campo3 + digito3 + campo4 + /*digito4*/ + campo5;

    const dadosBoleto = {
      linhaDigitavel,
      fatorVencimento,
      valor,
      nossoNumero,
      campoLivre,
      digitoGeral,
      codigoBarra,
    };

    return dadosBoleto;
  } catch (error) {
    console.log('Falha ao gerar dados do boleto', error);
    return null;
  }
}

function getNossoNumero(id: string, agencia: string, posto: string, codigoCedente: string) {
  let i = 19;
  let j = 1;
  let soma = 0;
  let digito = 0;

  const texto = agencia.padStart(4, '0') + posto.padStart(2, '0') + codigoCedente.padStart(5, '0') + id.padStart(8, '0');

  while (i >= 1) {
    j++;

    if (j === 10) j = 2;

    const valor = Number(copy(texto, i, i));
    soma += j * valor;

    i--;
  }

  const restoDivisao = soma % 11;
  digito = 11 - restoDivisao;

  if (restoDivisao === 0 || restoDivisao === 1) digito = 0;

  return id.padStart(8, '0') + digito.toString();
}

function getValor(valor: number) {
  const valorFormatado = valor.toFixed(2).replace(/\D/g, '');
  return valorFormatado.padStart(10, '0');
}

function getDigitoCampoLivre(texto: string) {
  let i = 24;
  let j = 1;
  let soma = 0;
  let digito = 0;

  while (i >= 1) {
    j++;

    if (j === 10) j = 2;

    let valor = Number(copy(texto, i, i));
    soma += valor * j;
    i--;
  }

  const restoDivisao = soma % 11;

  if (restoDivisao > 1) digito = 11 - restoDivisao;

  return String(digito);
}

function getDigitoGeral(texto: string) {
  let i = 43;
  let j = 1;
  let soma = 0;
  let digito = 0;

  while (i >= 1) {
    j++;

    if (j === 10) j = 2;

    const valor = Number(copy(texto, i, i));
    soma += j * valor;

    i--;
  }

  const restoDivisao = soma % 11;
  digito = 11 - restoDivisao;

  if (digito <= 1 || digito >= 10) digito = 1;

  return String(digito);
}

function getDigito(texto: string) {
  let i = texto.length;
  let j = 1;
  let total = 0;
  let soma = 0;
  let digito = 0;

  while (i >= 1) {
    j = j === 1 ? 2 : 1;

    let valor = Number(copy(texto, i, i));
    total = valor * j;

    if (total >= 10) {
      valor = Number(copy(total, 1, 1)) + Number(copy(total, 2, 2));
    } else {
      valor = total;
    }

    soma += valor;
    i--;
  }

  const uni = Number(copy(soma, String(soma).length, String(soma).length));
  digito = 10 - uni;
  if (digito === 10) digito = 0;
  return String(digito);
}
